/**
 * Copyright (c) 2025 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Checks if the current user has the given role
 *
 * @param curRole - The current user's role
 * @param roles - The roles to check
 * @returns {boolean} - Returns true if the current user has the given role, otherwise returns false
 */

export const hasUserRole = (curRole: string | undefined, roles: string | string[] | undefined): boolean => {
  if (!curRole) {
    return false
  }

  const currentUserRoles = curRole

  if (typeof roles === 'string') {
    if (typeof currentUserRoles === 'string') {
      // roles to check is a string, currentUser.roles is a string
      return currentUserRoles === roles
    }
  }

  if (Array.isArray(roles)) {
    if (Array.isArray(currentUserRoles)) {
      // roles to check is an array, currentUser.roles is an array
      return currentUserRoles?.some((allowedRole) => roles.includes(allowedRole))
    }
    if (typeof currentUserRoles === 'string') {
      // roles to check is an array, currentUser.roles is a string
      return roles.some((allowedRole) => currentUserRoles === allowedRole)
    }
  }

  // roles not found
  return false
}
